import React from 'react';
import { render } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { defaultConfig } from '../react/config/reactToastify/configs';

const toastRoot = document.createElement('div');
toastRoot.id = 'toast-root';
document.body.appendChild(toastRoot);

render(<ToastContainer {...defaultConfig} />, toastRoot);
